/* ============================================================
   STRUKT — hair-quiz.js
   Simple tag-based quiz: each answer casts a vote for a tag,
   whichever tag has the most votes at the end determines which
   "result" block (and its recommended product) is shown.
   ============================================================ */
(function () {
  'use strict';

  var doc = document;
  function qs(sel, ctx) { return (ctx || doc).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || doc).querySelectorAll(sel)); }

  var root = qs('[data-hair-quiz]');
  if (!root) return;

  var STORAGE_KEY = 'strukt_quiz_tallies';
  var questionSteps = qsa('[data-quiz-question]', root);
  var emailGateStep = qs('[data-quiz-step="email"]', root);
  var resultStep = qs('[data-quiz-step="result"]', root);
  var resultCards = qsa('[data-result-tag]', root);
  var gateForm = qs('.hair-quiz__gate-form', root);
  var gateSubmit = qs('[data-quiz-gate-submit]', root);
  var progressTrack = qs('[data-quiz-progress-track]', root);
  var progressFill = qs('[data-quiz-progress-fill]', root);
  var tallies = {};
  var currentIndex = -1; // -1 = intro
  var unlocked = false;
  var gateSubmitLabel = gateSubmit ? gateSubmit.textContent : '';

  function showStep(step) {
    qsa('[data-quiz-step]', root).forEach(function (s) { s.hidden = true; });
    if (step) step.hidden = false;
  }

  function updateProgress(index) {
    if (!progressTrack || !progressFill) return;
    if (index < 0 || index >= questionSteps.length) {
      progressTrack.hidden = true;
      return;
    }
    progressTrack.hidden = false;
    var pct = Math.round(((index + 1) / questionSteps.length) * 100);
    progressFill.style.width = pct + '%';
  }

  function goToQuestion(index) {
    currentIndex = index;
    updateProgress(index);
    if (index < 0) {
      showStep(qs('[data-quiz-step="intro"]', root));
      return;
    }
    if (index >= questionSteps.length) {
      if (unlocked || !emailGateStep) {
        showResult();
      } else {
        showStep(emailGateStep);
      }
      return;
    }
    showStep(questionSteps[index]);
  }

  /* Shopify's /contact endpoint rejects plain fetch() POSTs (and even a
     native form targeting a hidden iframe) with a "Missing CAPTCHA token"
     error — it only accepts a genuine top-level form submission, which
     means a full page reload. So we persist the in-progress answers right
     before that navigation, then restore them below once the page comes
     back with form.posted_successfully? true, and jump straight to the
     unlocked result instead of making them redo the quiz. */
  if (gateForm) {
    gateForm.addEventListener('submit', function () {
      var emailInput = qs('[data-quiz-gate-email]', gateForm);
      if (!emailInput || !emailInput.value) return;
      gateSubmit.disabled = true;
      gateSubmit.textContent = 'Unlocking…';
      try { window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(tallies)); } catch (e) {}
    });
  }

  /* Shopify appends ?customer_posted=true to the URL after a successful
     /contact submission redirect — that's the real, reliable success signal
     (form.posted_successfully? doesn't survive the redirect reliably here). */
  var justUnlocked = /[?&]customer_posted=true\b/.test(window.location.search);
  if (justUnlocked && window.history && window.history.replaceState) {
    var cleanQuizUrl = window.location.pathname + window.location.search.replace(/[?&]customer_posted=true\b/, '').replace(/^&/, '?') + window.location.hash;
    window.history.replaceState(null, '', cleanQuizUrl);
  }

  if (justUnlocked) {
    var savedTallies = null;
    try { savedTallies = JSON.parse(window.sessionStorage.getItem(STORAGE_KEY) || 'null'); } catch (e) {}
    if (savedTallies) {
      tallies = savedTallies;
      unlocked = true;
      try { window.sessionStorage.removeItem(STORAGE_KEY); } catch (e) {}
      window.dispatchEvent(new CustomEvent('strukt:toast', { detail: 'You\'re in — here\'s your routine.' }));
      showResult();
    }
  }

  function showResult() {
    var winningTag = null;
    var best = -1;
    Object.keys(tallies).forEach(function (tag) {
      if (tallies[tag] > best) {
        best = tallies[tag];
        winningTag = tag;
      }
    });

    resultCards.forEach(function (card) {
      card.hidden = card.dataset.resultTag !== winningTag;
    });

    // fallback: if nothing matched (e.g. tags misconfigured), show the first result card
    if (!qs('[data-result-tag]:not([hidden])', root) && resultCards.length) {
      resultCards[0].hidden = false;
    }

    showStep(resultStep);
  }

  var startBtn = qs('[data-quiz-start]', root);
  if (startBtn) {
    startBtn.addEventListener('click', function () { goToQuestion(0); });
  }

  questionSteps.forEach(function (step, index) {
    var answerBtns = qsa('[data-quiz-answer]', step);
    answerBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var tag = btn.dataset.tag;
        if (tag) tallies[tag] = (tallies[tag] || 0) + 1;
        answerBtns.forEach(function (b) { b.classList.remove('is-selected'); });
        btn.classList.add('is-selected');
        setTimeout(function () { goToQuestion(index + 1); }, 220);
      });
    });
    var backBtn = qs('[data-quiz-back]', step);
    if (backBtn) {
      backBtn.addEventListener('click', function () { goToQuestion(index - 1); });
    }
  });

  qsa('[data-quiz-add-routine]', root).forEach(function (btn) {
    btn.addEventListener('click', function () {
      var card = btn.closest('[data-result-tag]');
      if (!card) return;
      var items = qsa('[data-quiz-routine-item]', card).map(function (el) {
        return { id: el.dataset.variantId, quantity: 1 };
      }).filter(function (i) { return i.id; });
      if (!items.length) return;

      btn.disabled = true;
      var originalLabel = btn.textContent;
      btn.textContent = 'Adding…';

      fetch((window.routes && window.routes.cart_add_url || '/cart/add') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (data.status) {
            window.dispatchEvent(new CustomEvent('strukt:toast', { detail: data.description || 'Could not add your routine to the cart.' }));
            btn.disabled = false;
            btn.textContent = originalLabel;
            return;
          }
          window.location.href = (window.routes && window.routes.cart_url) || '/cart';
        })
        .catch(function () {
          window.dispatchEvent(new CustomEvent('strukt:toast', { detail: 'Something went wrong. Please try again.' }));
          btn.disabled = false;
          btn.textContent = originalLabel;
        });
    });
  });

  var restartBtn = qs('[data-quiz-restart]', root);
  if (restartBtn) {
    restartBtn.addEventListener('click', function () {
      tallies = {};
      unlocked = false;
      if (gateSubmit) { gateSubmit.disabled = false; gateSubmit.textContent = gateSubmitLabel; }
      goToQuestion(-1);
    });
  }
})();
